import React from "react";

import { StackScreenProps } from "@react-navigation/stack";
import { RootStackParamList } from "../../navigations/RootNavigation";
import IJMEditorNavigator from "../../components/editors/ijm/IJMEditorNavigator";

type IJMEditorNavScreenProps = StackScreenProps<RootStackParamList, "IJMEditorNavScreen">;

const IJMEditorNavScreen: React.FC<IJMEditorNavScreenProps> = () => {
    return <IJMEditorNavigator />;
};

export default IJMEditorNavScreen;
